import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { Component, OnInit } from "@angular/core";
import { MatChipInputEvent } from "@angular/material/chips";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertController, LoadingController } from "@ionic/angular";
import { Storage } from "@ionic/storage";
import { STORAGE } from "../../../constant/storages";
import { ApiserviceService } from "../../../httpservice/apiservice.service";
import { AppService } from "../../../services/app.service";
import { TEXT } from "../../../text_control";
import { errMsg } from "../../../text_control/error-msg";
import { ADDRESS } from "../../../text_control/text_address";
import { BTN } from "../../../text_control/text_button";
import { TEXT_TABLE } from "../../../text_control/text_table";
import { _getStorage, _setStorage } from "../../../utils/local-storage";

export interface Fruit {
  numbers: string;
}

@Component({
  selector: "app-replace-select-taxinvoice",
  templateUrl: "./replace-select-taxinvoice.component.html",
  styleUrls: ["./replace-select-taxinvoice.component.scss"],
})
export class ReplaceSelectTaxinvoiceComponent implements OnInit {
  public text_addr: any = {};
  dataedit1 = [];
  dataedit: any = {};
  dataaddress: any;
  dataitem: any;
  datatax: any;
  dataAddress: any;
  dataAddr: any;
  myparam: any;
  phone = "";
  building_name = "";
  showbranch2 = true;
  buyer_branch_no = "";
  buyer_main_branch_no = "";
  radio_group = "";
  disable_buyer = false;
  buyer_type;
  buyer_agree_tmp = "";
  postcode = "";
  showbtn1 = true;
  showbtn2 = false;

  dataTIVC: any;
  sub_district = "";
  district = "";
  province = "";
  actice: any;

  showfont1 = false;
  showfont2 = false;
  showfont3 = false;

  showaddress = true;
  showname = true;
  senddata: any;
  taxinvoiceno: any;
  data: any;
  zipcode: any;
  showbranch = false;
  dataprovinces: any;
  datadistricts: any;
  datasubdistricts: any;

  template_lang: any;

  dataCountry: any = [];
  country: any = "";
  dataCountrysearch: any = [];

  showTH = false;
  showEN = true;
  showradio = false;

  addrENCountry = "";
  addrENPostCode = "";
  addrENProvince = "";
  addrEN = "";
  addrENOther = "";

  showOther = false;
  redioaddress = "1";

  emailEN = "";
  telEN = "";
  itemEN: any;

  showaddrEN = false;
  showaddrTH = false;
  notaxid = false;
  showfonttaxid = false;
  Active = 2;
  showBranchNo = false;
  showradio_branch = false;

  dataProvince: any;
  groupAddress: any;
  groupProvince: any;
  isFindAddress = false;
  searchAddress = "";
  searchProvince = "";
  addressManual = false;

  text: any;
  textBTN: any;
  textTB: any;

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  isAddress = false;
  addressline1 = "";

  constructor(
    public appService: AppService,
    public alertController: AlertController,
    public route: Router,
    public apiservice: ApiserviceService,
    public router: ActivatedRoute,
    public storeg: Storage,
    public loadingController: LoadingController
  ) {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);

    this.text_addr = ADDRESS;
    this.text = TEXT;
    this.textBTN = BTN;
    this.textTB = TEXT_TABLE;
    this.reloadcountry();

    this.dataaddress = _getStorage(STORAGE.DATA_SEARCH_REPLACE);
    this.dataitem = this.dataaddress.datatax.data.customerData[0];
    console.log("this.dataitem==========:: ", this.dataitem);

    this.dataAddr = this.dataitem.address_detail[0];
    this.sub_district = this.dataAddr.sub_district;
    this.district = this.dataAddr.district;
    this.province = this.dataAddr.province;
    this.postcode = this.dataAddr.postcode;
    this.itemEN = this.dataitem.address_detail[0];
    this.dataTIVC = this.dataaddress.taxnumber.selectDocument;
    this.taxinvoiceno = this.dataaddress.datatax.data.taxinvoice_no;
    this.isAddress = this.dataAddr.is_addresstxt;
    this.addressline1 = this.dataAddr.addressline1;
    this.dataphone = this.dataAddr.phone.split(",");
    if (this.dataphone[0] === "") {
      this.dataphone = "";
    }
    this.buyer_type = String(this.dataitem.buyer_type);
    this.template_lang = this.dataitem.template_lang;
    this.buyer_agree_tmp = this.dataitem.buyer_agree_tmp;

    this.showbtn1 = true;
    this.showbtn2 = false;
    this.notaxid = false;
    this.showfonttaxid = false;

    if (this.dataTIVC === "TIVC01") {
      this.showBranchNo = true;
      this.showbranch = false;
      this.showaddrradio();
      this.showaddress = true;
      this.showname = false;
      this.showradio = true;
      this.showaddrTH = true;
      this.showaddrEN = true;
      this.showEN = true;
      this.showTH = true;
      this.showradio_branch = true;
    } else if (this.dataTIVC === "TIVC02") {
      this.showBranchNo = true;
      this.showbranch = false;
      this.showaddress = false;
      this.showradio = true;
      this.showradio_branch = true;
      this.showaddrradio();
    } else if (this.dataTIVC === "TIVC99") {
      this.showbranch = true;
      this.showBranchNo = false;
      this.showname = false;
      this.showaddress = false;
      this.showradio = false;
      this.showradio_branch = false;
      this.showaddrradio();
    }
    if (this.dataitem.buyer_type === "0") {
      this.showbranch = false;
      this.showfont1 = true;
      this.showfont2 = false;
      this.showfont3 = false;
      this.notaxid = true;
    } else if (this.dataitem.buyer_type === "1") {
      this.showbranch = true;
      this.showfont1 = false;
      this.showfont2 = true;
      this.showfont3 = false;
      this.notaxid = true;
      if (this.dataitem.buyer_main_branch_no) {
        this.radio_group = this.dataitem.buyer_main_branch_no;
      } else {
        this.radio_group = "1";
      }
    } else if (this.dataitem.buyer_type === "2") {
      this.showbranch = false;
      this.showfont1 = false;
      this.showfont2 = false;
      this.showfont3 = true;
      this.notaxid = true;
    } else if (this.dataitem.buyer_type === "3") {
      this.notaxid = false;
      this.showfonttaxid = true;
      this.showbranch = false;
      this.showfont1 = false;
      this.showfont2 = false;
      this.showfont3 = false;
    }

    // ============ START ADDRESS EN ============//
    let country: any;
    country = this.dataCountry.filter(
      (i) =>
        i.name.trim().toLowerCase() ===
        this.itemEN.inter_country.trim().toLowerCase()
    );
    if (country.length > 0) {
      this.addrENCountry = country[0].name + ":" + country[0].code;
    }
    this.addrENPostCode = this.itemEN.inter_postcode;
    this.addrENProvince = this.itemEN.inter_province;
    this.addrEN = this.itemEN.inter_address_line1;
    this.emailEN = this.itemEN.email;
    this.telEN = this.itemEN.inter_tel;

    // ============ START ADDRESS EN ============//
  }
  acticereplace = 2;
  showaddrradio() {
    if (this.itemEN.type_addr === "1") {
      this.redioaddress = "1";
      this.showaddress = false;
      this.showEN = true;
      this.showTH = false;
    } else if (this.itemEN.type_addr === "2") {
      this.redioaddress = "2";
      this.showaddress = false;
      this.showEN = false;
      this.showTH = true;
    }
    this.ionViewDidEnter();
  }
  ionViewDidEnter() {
    this.router.queryParams.subscribe((params) => {
      if (params.noName === "no_replace") {
        this.Active = Number(params.selectedIndex);
      } else {
        this.Active = 2;
      }
    });
  }

  checkAddress(e) {
    console.log("checkAddress event =======:: ", e);
    this.isAddress = e.detail.checked;
  }

  checkbranch1() {
    this.dataitem.buyer_branch_no = "";
    this.showBranchNo = true;
  }
  checkbranch2() {
    this.showBranchNo = false;
  }

  searchaddrEN(search) {
    let val: string = search;
    if (val.trim() !== "") {
      this.dataCountry = this.dataCountrysearch.filter((item) => {
        return item.name.toLowerCase().indexOf(val.toLowerCase()) > -1;
      });
    }

    if (val === "") {
      this.reloadcountry();
    }
  }
  reloadcountry() {
    this.dataCountry = this.appService.Country;
    this.dataCountrysearch = this.appService.Country;
  }

  ngOnInit() {
    this.addressManual = false;
    this.groupAddress = this.appService.address_thai;
    window.onclick = function (event) {
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      var showprovince = document.getElementById("showSelectProvince");
      var notshowprovince = document.getElementById("notshowselectProvince");
      if (x !== null) {
        x.style.display = "none";
        y.style.display = "none";
      }
      if (showprovince !== null) {
        showprovince.style.display = "none";
        notshowprovince.style.display = "none";
      }
    };
    let groupData = [];
    this.groupAddress.forEach((v, i) => {
      const index = groupData.findIndex((f) => f.province === v.province);
      if (index === -1) {
        groupData = [...groupData, v];

        this.dataProvince = groupData;
      } else {
        return;
      }
    });

    this.fruits = [];
    for (let i of this.dataphone) {
      this.fruits.push({
        numbers: i,
      });
    }
  }

  filterAddress(e) {
    let val = e.target.value;
    if (val.trim() !== "") {
      this.groupAddress = this.appService.address_thai.filter((item) => {
        return (
          String(item.zipcode).indexOf(val) > -1 ||
          item.province.indexOf(val) > -1 ||
          item.amphoe.indexOf(val) > -1 ||
          item.district.indexOf(val) > -1
        );
      });
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }

  selectAddress(item) {
    this.sub_district = item.district;
    this.district = item.amphoe;
    this.province = item.province;
    this.dataAddr.postcode = item.zipcode;
    this.isFindAddress = false;
    this.searchAddress = "";
  }
  filterProvince(e) {
    let val = e.target.value;
    if (val.trim() !== "") {
      this.groupProvince = this.dataProvince.filter((item) => {
        return item.province.indexOf(val) > -1;
      });
      var x = document.getElementById("showSelectProvince");
      var y = document.getElementById("notshowselectProvince");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }
  selectProvince(item) {
    this.province = item.province;
    this.searchProvince = "";
  }
  clearAddress(name) {
    if (name === "Postcode") {
      this.dataAddr.postcode = "";
    }
    if (name === "Province") {
      this.province = "";
    }
    if (name === "District") {
      this.district = "";
    }
    if (name === "SubDistrict") {
      this.sub_district = "";
    }
  }

  checkbranch(e) {
    this.dataitem.buyer_branch_no = e.target.value.match(/[0-9]*/)[0];
  }

  datasave: any;
  async confirmAlert() {
    let isConfirm: boolean = false;
    let province: any = this.province;
    let district: any = this.district;
    let sub_district: any = this.sub_district;

    let phones = [];

    for (let i of this.fruits) {
      phones.push(i.numbers);
    }
    console.log("this.radio_group", this.radio_group);

    this.appService.setActive(2);
    if (this.redioaddress === "1") {
      if (!isConfirm) {
        let filterPostcode = this.groupAddress.filter(
          (f) => f.zipcode === Number(this.dataAddr.postcode)
        );
        let filterProvince = this.groupAddress.filter(
          (f) => f.province === this.province
        );

        if (this.dataitem.buyer_company_name === "") {
          this.ErrorMsg(errMsg.buyer_company_name);
          return;
        }
        if (
          this.dataitem.buyer_type === "1" &&
          this.radio_group === "1" &&
          this.dataitem.buyer_branch_no === ""
        ) {
          this.ErrorMsg(errMsg.buyer_branch_no);
          return;
        }
        console.log("this.isAddress", this.isAddress);
        if (this.isAddress) {
          if (!this.addressline1) {
            this.ErrorMsg(errMsg.errorAddressline1);
            return;
          }
          if (!this.dataAddr.postcode) {
            this.ErrorMsg(errMsg.postcode);
            return;
          }
          if (this.dataAddr.postcode && filterPostcode.length === 0) {
            this.ErrorMsg(errMsg.notpostcode);
            return;
          }
          if (this.dataAddr.email && !this.validateEmail(this.dataAddr.email)) {
            this.ErrorMsg(errMsg.errorEmail);
            return;
          }
          isConfirm = true;
        } else {
          if (!this.dataAddr.house_no) {
            this.ErrorMsg(errMsg.house_no);
            return;
          }
          if (!this.dataAddr.postcode) {
            this.ErrorMsg(errMsg.postcode);
            return;
          }
          if (this.dataAddr.postcode && filterPostcode.length === 0) {
            this.ErrorMsg(errMsg.notpostcode);
            return;
          }
          if (!district) {
            this.ErrorMsg(errMsg.district);
            return;
          }
          if (!sub_district) {
            this.ErrorMsg(errMsg.sub_district);
            return;
          }
          if (!province) {
            this.ErrorMsg(errMsg.province);
            return;
          }
          if (!province && filterProvince.length === 0) {
            this.ErrorMsg(errMsg.notprovince);
            return;
          }
          if (this.dataAddr.email && !this.validateEmail(this.dataAddr.email)) {
            this.ErrorMsg(errMsg.errorEmail);
            return;
          }
          isConfirm = true;
        }
      }
    } else {
      if (!isConfirm) {
        if (!this.dataitem.buyer_company_name) {
          this.ErrorMsg(errMsg.buyer_company_name);
          return;
        }

        if (
          this.dataitem.buyer_type === "1" &&
          this.radio_group === "1" &&
          !this.dataitem.buyer_branch_no
        ) {
          this.ErrorMsg(errMsg.buyer_branch_no);
          return;
        }

        if (!this.addrENProvince) {
          this.ErrorMsg(errMsg.addrENProvince);
          return;
        }

        if (!this.addrENPostCode) {
          this.ErrorMsg(errMsg.addrENPostCode);
          return;
        }

        if (!this.addrENCountry) {
          this.ErrorMsg(errMsg.addrENCountry);
          return;
        }

        if (this.emailEN && !this.validateEmail(this.emailEN)) {
          this.ErrorMsg(errMsg.errorEmail);
          return;
        }
        isConfirm = true;
      }
    }
    console.log("isConfirm ==> ", isConfirm);
    if (isConfirm) {
      const data = {
        typeUpdate: this.dataTIVC,
        taxinvoice_no: this.taxinvoiceno,
        typeUpdateDesc: this.dataaddress.taxnumber.other,
        userBu: this.userBu,
        userLoc: this.userLoc,
        userRole: this.userRole,
        userSource: this.userSource,
        user_id: this.userID,
        mtrans_id: this.dataaddress.datatax.data.mtrans_id,
        data: {
          buyer_id: this.dataitem.buyer_id,
          buyer_company_name: this.dataitem.buyer_company_name,
          buyer_people_id: this.dataitem.buyer_people_id,
          buyer_main_branch_no:
            this.radio_group === "00000" ? this.radio_group : "",
          buyer_branch_no:
            this.radio_group === "1"
              ? this.dataitem.buyer_branch_no.padStart(5, "0")
              : "",
          buyer_citizen_id: this.dataitem.buyer_citizen_id,
          buyer_tax_id: this.dataitem.buyer_tax_id,
          buyer_type: this.dataitem.buyer_type,
          buyer_passpost_id: this.dataitem.buyer_passpost_id,
          buyer_agree_tmp: this.dataitem.buyer_agree_tmp,
          user_id: this.userID,
          buyer_status: this.dataitem.buyer_status,
          template_lang: this.template_lang,
          address_detail: {
            addr_id: this.dataAddr.addr_id,
            building_no: this.dataAddr.building_no,
            building_name: this.dataAddr.building_name,
            house_no: this.dataAddr.house_no,
            village_no: this.dataAddr.village_no,
            room_no: this.dataAddr.room_no,
            floor: this.dataAddr.floor,
            lane: this.dataAddr.lane,
            road: this.dataAddr.road,
            sub_district: this.sub_district,
            district: this.district,
            province: this.province,
            postcode: String(this.dataAddr.postcode),
            phone: phones.join(","),
            email:
              this.redioaddress === "1" ? this.dataAddr.email : this.emailEN,
            buyer_id: this.dataAddr.buyer_id,
            address_status: this.dataAddr.address_status,
            seller_id: this.dataAddr.seller_id,
            addr_agree_tmp: this.dataAddr.addr_agree_tmp,
            user_id: this.userID,
            type_addr: this.redioaddress,
            inter_address_line1: this.addrEN === undefined ? "" : this.addrEN,
            inter_country: this.addrENCountry,
            inter_fax: "",
            inter_postcode: this.addrENPostCode,
            inter_province: this.addrENProvince,
            inter_tel: this.telEN === undefined ? "" : this.telEN,
            is_addresstxt: this.isAddress,
            addressline1: this.addressline1 || "",
          },
        },
      };

      console.log("====== req update replace =======", data);
      try {
        this.apiservice
          ._post(
            this.apiservice.apiUrl + this.apiservice.replaceEditCustomer,
            data
          )
          .then(async (res: any) => {
            console.log("====== res update replace =======", res);

            if (res.statusCode === 200) {
              this.datasave = res.data;
              this.senddata = res.data;

              this.dataedit = res.data[0];
              const alert = await this.alertController.create({
                cssClass: "my-custom-class",
                header: "บันทึกข้อมูลเรียบร้อย",
                buttons: [
                  {
                    text: "OK",
                    cssClass: "alertButton",
                    handler: (blah) => {
                      this.showbtn2 = true;
                      this.showbtn1 = false;
                      this.showname = true;
                      this.showaddress = true;
                      this.showEN = true;
                      this.showTH = true;
                      this.showaddrEN = true;
                      this.showaddrTH = true;
                    },
                  },
                ],
              });
              await alert.present();
            } else {
              this.ErrorMsg(res.statusMessage);
            }
          });
      } catch (error) {
        // this.ErrorMsg(errMsg.error);
      }
    }
  }

  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
          handler: (blah) => {
            //
          },
        },
      ],
    });
    await alert.present();
  }

  checkphone(e) {
    this.phone = e.target.value.match(/[0-9]*/)[0];
  }
  checkphoneEN(e) {
    this.telEN = e.target.value.match(/[0-9]*/)[0];
  }

  checkPostcodeEN(e) {
    this.addrENPostCode = e.target.value.match(/[0-9]*/)[0];
  }
  checkpostcode(e) {
    this.dataAddr.postcode = e.target.value.match(/[0-9]*/)[0];
  }

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  dataphone: any = [];
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  fruits: Fruit[];

  add(e: MatChipInputEvent, n): void {
    const input = e.input;
    const value = e.value;

    // Add our fruit
    if ((value || "").trim()) {
      this.fruits.push({ numbers: value.trim() });
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }
  }

  remove(fruit: Fruit): void {
    const index = this.fruits.indexOf(fruit);

    if (index >= 0) {
      this.fruits.splice(index, 1);
    }
  }

  gotoreplacecheck() {
    this.appService.setActive(3);
    _setStorage(STORAGE.DATA_CHECK_REPLACE, this.senddata);
    // localStorage.setItem("DatacheckReplace", JSON.stringify(this.senddata));
    if (this.Active === 2) {
      this.route.navigate(["/replace-checkdata-taxinvoice"]);
    } else {
      this.route.navigate(["/replace-checkdata-taxinvoice"], {
        queryParams: { noName: "no_replace", selectedIndex: "4" },
      });
    }
  }
  checkemail(e) {
    this.dataAddr.email = e.target.value.match(/[0-9a-z._@A-Z- ]*/)[0];
  }
  checkemailEN(e) {
    this.emailEN = e.target.value.match(/[0-9a-z._@A-Z- ]*/)[0];
  }

  checkaddressTH() {
    this.template_lang = "TH";
    this.showaddress = false;
    this.showEN = true;
    this.showTH = false;
  }
  checkaddressEN() {
    this.template_lang = "EN";
    this.showaddress = false;
    this.showEN = false;
    this.showTH = true;
  }

  checkaddrENOther() {
    this.showOther = this.addrENCountry !== "Other" ? false : true;
  }

  validateEmail(email: string): boolean {
    const re =
      /^(([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
}
